var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.921 3.688V1.486c-1.44-.367-4.686-.88-6.133 0-1.809 1.101-2.36 2.36-2.36 3.303v2.595h-2.044v2.752h2.045v8.415c-.734-.236-2.737-.692-4.876-.63-2.674.08-5.112 2.439-5.505 5.978-.393 3.539 1.73 5.977 5.033 6.842 3.303.865 5.19-.63 6.213-1.73.92-.992 1.522-2.322 1.862-3.075l.104-.229v-15.57h4.953V7.384H20.26V5.34c.104-.367.502-1.211 1.257-1.652.755-.44 3.25-.183 4.404 0zM13.732 27.99a3.775 3.775 0 1 0 .001-7.55 3.775 3.775 0 0 0 .001 7.55z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/AUTO.ed09cc14c6ff322cbdcbaa252ce1e88c.svg";
export { ForwardRef as ReactComponent };